export enum NodeType {
  PROMPT_INPUT = 'PROMPT_INPUT',
  MEDIA_UPLOAD = 'MEDIA_UPLOAD',
  IMAGE_GENERATOR = 'IMAGE_GENERATOR',
  VIDEO_GENERATOR = 'VIDEO_GENERATOR',
  IMAGE_EDITOR = 'IMAGE_EDITOR',
  AUDIO_GENERATOR = 'AUDIO_GENERATOR',
  TEXT_NODE = 'TEXT_NODE',
  SCRIPT_NODE = 'SCRIPT_NODE',
  VIDEO_COMPOSE = 'VIDEO_COMPOSE',
  PANORAMA_GENERATOR = 'PANORAMA_GENERATOR',
  DIRECTOR = 'DIRECTOR',
  DETAIL_PAGE = 'DETAIL_PAGE',
  LAYER_EDIT = 'LAYER_EDIT',
  GROUP = 'GROUP',
}

export enum NodeStatus {
  IDLE = 'IDLE',
  /** 排队等待生成（前端串行队列占位，任务尚未提交后端；不写 pendingTaskId，刷新后由持久化恢复重置为 IDLE） */
  QUEUED = 'QUEUED',
  WORKING = 'WORKING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum DetailPageMode {
  ENTRY = 'ENTRY',
  PLANNER = 'PLANNER',
  DESIGNER = 'DESIGNER',
}

/** 详情页单节点流水线四阶段（CONFIG→PLANNING→DESIGNING→CONSUME） */
export enum DetailPageStage {
  /** 启动配置：填产品图/卖点/竞品/风格/模型 */
  CONFIG = 'CONFIG',
  /** 策划执行中（含策划师会话询问） */
  PLANNING = 'PLANNING',
  /** 设计执行中（含设计师会话询问） */
  DESIGNING = 'DESIGNING',
  /** 成果消费：分块逐屏出图 */
  CONSUME = 'CONSUME',
}
